<template>
    <div class="error">You must be Lost...</div>
</template>

<script>
export default {
    name: "NotFoundComponent",
    data() {
        return {};
    }
};
</script>

<style>
.error{
    text-align: center;
    font-style: italic;
    margin-top: 12.5rem /* 200/16 */;
    font-size: 1.5625rem /* 25/16 */;
}
</style>
